'use client';

import { useRef, type ReactElement, type ReactPortal } from 'react';
import Modal from '../modal';
import SearchModalContent, { ABORT_SEARCH_REASON } from './ModalContent';
import { createPortal } from 'react-dom';
import type { SearchModalPpProfile } from '../types';

const SearchModalModal = ({
	isOpen,
	onClose,
	endpoint,
	ppProfile,
	ppMode,
	allowAnonymousOnPP,
}: {
	isOpen: boolean;
	onClose: () => void;
	endpoint: string;
	ppProfile?: SearchModalPpProfile;
	ppMode?: boolean;
	allowAnonymousOnPP?: boolean;
}): ReactElement | ReactPortal | null => {
	const controller = useRef<AbortController>(undefined);
	if (!isOpen) return null;
	return createPortal(
		<div className="tailwind-root SearchModal">
			<Modal
				close={() => {
					controller.current?.abort(ABORT_SEARCH_REASON);
					onClose();
				}}
				mobileFullScreen={false}
				mobileAnimate={true}
				mainContainerClassName="@container/layout"
				focusContainerClassNames="min-h-[95svh] md:min-h-[540px] !h-[95svh] md:!h-[540px]"
				contentContainerClassNames="h-full flex flex-col !justify-start"
			>
				<SearchModalContent
					endpoint={endpoint}
					abortController={controller}
					ppProfile={ppProfile}
					ppMode={ppMode}
					allowAnonymousOnPP={allowAnonymousOnPP}
				/>
			</Modal>
		</div>,
		document.body
	);
};

export default SearchModalModal;
